import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useClosestStoreZipcode from 'hooks/useClosestStoreZipcode';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_CUSTOM_LIST_PRODUCT_DATA } from '@/graphql/queries';
import { storeUrlSlugMapping } from 'commons/ShowroomStaticData';
const useProductListingProductsOnDisplay = t0 => {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    skip: t2
  } = t1;
  const skip = t2 === undefined ? false : t2;
  const location = useLocation();
  let t3;
  if ($[2] !== location?.pathname) {
    t3 = location?.pathname.split("/").includes("showrooms");
    $[2] = location?.pathname;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const isShowroomPage = t3;
  const closestStoreLocation = useClosestStoreZipcode();
  const closestStoreUrl = closestStoreLocation?.storeLocation?.url || null;
  const t4 = storeUrlSlugMapping[closestStoreUrl]?.slug;
  let t5;
  if ($[4] !== t4) {
    t5 = {
      slug: t4
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = skip || isShowroomPage || !storeUrlSlugMapping[closestStoreUrl]?.slug;
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = {
      variables: t5,
      skip: t6
    };
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const {
    data: showroomDisplayData
  } = useSuspenseQuery(GET_CUSTOM_LIST_PRODUCT_DATA, t7);
  let t8;
  if ($[9] !== showroomDisplayData?.getCustomListProductData?.products_list) {
    t8 = showroomDisplayData?.getCustomListProductData?.products_list?.map(_temp).filter(Boolean) || [];
    $[9] = showroomDisplayData?.getCustomListProductData?.products_list;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const productsOnDisplay = t8;
  const t9 = storeUrlSlugMapping[closestStoreUrl]?.slug;
  let t10;
  if ($[11] !== productsOnDisplay || $[12] !== t9) {
    t10 = {
      slug: t9,
      productsOnDisplay
    };
    $[11] = productsOnDisplay;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
};
export default useProductListingProductsOnDisplay;
function _temp(item) {
  return item.id;
}